import React from 'react';
import { Text, View, StyleSheet } from 'react-native';
import type { LucideIcon } from 'lucide-react-native';
import { useTheme, SPACING, TYPOGRAPHY } from '../../theme';

interface StatCardProps {
  value: number | string;
  label: string;
  /** Small leading icon above the value (e.g. dashboard stats). */
  icon?: LucideIcon;
  /** Override the value color (e.g. a readiness band color). */
  valueColor?: string;
}

export function StatCard({ value, label, icon: Icon, valueColor }: StatCardProps) {
  const { colors } = useTheme();

  return (
    <View style={styles.card}>
      {Icon && (
        <View style={styles.iconWrap}>
          <Icon size={16} color={colors.textTertiary} />
        </View>
      )}
      <Text style={[styles.value, { color: valueColor ?? colors.text }]}>{value}</Text>
      <Text style={[styles.label, { color: colors.textSecondary }]}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  // Bare stats on canvas, like the profile StatsRow — not a paper card. The
  // caller separates them (see the agent hub's statsRow hairlines).
  card: {
    flex: 1,
    alignItems: 'center',
    paddingVertical: SPACING.md,
  },
  iconWrap: {
    marginBottom: SPACING.xxs,
  },
  value: {
    ...TYPOGRAPHY.statNumeral,
  },
  label: {
    ...TYPOGRAPHY.label,
    marginTop: SPACING.xxs,
  },
});
